<template>
    <common-modal
        :width="'medium'"
        class="invoice"
        @emitEvent="emitEvent($event, ['close'])"
        @close="emitEvent({ name: 'close' })"
    >
        <common-content-spacer height="large">
            <div class="invoice__header">
                <div class="invoice__header--logo">
                    <svg>
                        <use xlink:href="#picture-logo" />
                    </svg>
                    <span>{{ $t('pages.billing.billing.table.invoice') }}</span>
                </div>
                <common-button
                    :label="$t('pages.billing.billing.invoice_modal.download')"
                    :isSubmittable="false"
                    size="small-font"
                    type="secondary"
                    @click="downloadInvoice"
                ></common-button>
            </div>
            <div class="invoice__table">
                <table class="tracking-listing">
                    <thead>
                        <tr>
                            <th>{{ $t('pages.billing.billing.invoice_modal.subscription') }}</th>
                            <th>{{ $t('pages.billing.billing.invoice_modal.period') }}</th>
                            <th>
                                {{ $auth.getPractice().practiceType === PracticeTypeEnum.PHYSICIAN ? 'Users' : 'Locations' }}
                            </th>
                            <th>{{ $t('pages.billing.billing.invoice_modal.transcations') }}</th>
                            <th>{{ $t('pages.billing.billing.invoice_modal.amount') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ $t('pages.billing.billing.invoice_modal.premium') }}</td>
                            <td>
                                <p>
                                    <b>{{ formatDate(modalData.fromDate) }}</b>
                                </p>
                                <p>
                                    <b>{{ formatDate(modalData.toDate) }}</b>
                                </p>
                            </td>
                            <td>12</td>
                            <td>
                                <p>{{ modalData.numberOfReferrals }}</p>
                            </td>
                            <td>
                                <p>
                                    <b>${{ modalData.totalPrice / 100 }}</b>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import dayjs from 'dayjs'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import FileMixin from 'mixins/FileMixin'

    export default {
        mixins: [FileMixin],
        props: {
            modalData: { type: Object, required: true },
        },

        data() {
            return {
                isSending: false,
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },

        computed: {},
        methods: {
            downloadInvoice() {
                window.open(this.modalData.receiptUrl, '_blank')
            },

            formatDate(date) {
                return dayjs(date).format('MMMM D, YYYY')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .invoice {
        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &--logo {
                display: flex;
                align-items: flex-end;
                svg {
                    width: 100px;
                    margin-right: 20px;
                }

                span {
                    font-style: normal;
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 35px;
                    letter-spacing: 0.18px;
                    color: #333333;
                    margin-bottom: 42px;
                }
            }
        }
    }
</style>
